import { Form, Row, Col } from 'react-bootstrap';

const BankDetailsForm = ({ data, onChange, errors }) => {
  const handleChange = (field, value) => {
    onChange('bank', field, value);
  };

  const validateIFSC = (ifsc) => {
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    return ifscRegex.test(ifsc);
  };

  const handleIFSCChange = (value) => {
    const upperValue = value.toUpperCase();
    handleChange('ifscCode', upperValue);
  };

  return (
    <div>
      <h5 className="mb-3">Bank Details</h5>
      
      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Account Number</Form.Label>
            <Form.Control
              type="text"
              value={data.accountNumber}
              onChange={(e) => handleChange('accountNumber', e.target.value)}
              placeholder="Enter account number"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Account Holder Name</Form.Label>
            <Form.Control
              type="text"
              value={data.accountHolderName}
              onChange={(e) => handleChange('accountHolderName', e.target.value)}
              placeholder="As per bank records"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>Bank Name</Form.Label>
            <Form.Control
              type="text"
              value={data.bankName}
              onChange={(e) => handleChange('bankName', e.target.value)}
              placeholder="e.g., State Bank of India"
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Branch Name</Form.Label>
            <Form.Control
              type="text"
              value={data.branchName}
              onChange={(e) => handleChange('branchName', e.target.value)}
              placeholder="Enter branch name"
            />
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={6}>
          <Form.Group>
            <Form.Label>IFSC Code</Form.Label>
            <Form.Control
              type="text"
              value={data.ifscCode}
              onChange={(e) => handleIFSCChange(e.target.value)}
              placeholder="e.g., SBIN0001234"
              maxLength={11}
              isInvalid={data.ifscCode && !validateIFSC(data.ifscCode)}
            />
            <Form.Control.Feedback type="invalid">
              Invalid IFSC code format (e.g., SBIN0001234)
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
              Format: XXXX0XXXXXX (11 characters)
            </Form.Text>
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group>
            <Form.Label>Account Type</Form.Label>
            <Form.Select
              value={data.accountType}
              onChange={(e) => handleChange('accountType', e.target.value)}
            >
              <option value="Savings">Savings</option>
              <option value="Current">Current</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={12}>
          <Form.Group className="mb-4">
            <Form.Label>Upload Cancelled Cheque / Bank Statement</Form.Label>
            {data.document && typeof data.document === 'string' && (
              <div className="mb-2">
                <small className="text-success d-block mb-1">Document already uploaded</small>
                {data.document.startsWith('data:image') && (
                  <img src={data.document} alt="Bank Document Preview" style={{ height: '40px', marginRight: '10px', borderRadius: '4px' }} />
                )}
                <a href={data.document} target="_blank" rel="noopener noreferrer" className="btn btn-xs btn-link p-0 text-decoration-none">
                   View current document
                </a>
              </div>
            )}
            <Form.Control
              type="file"
              accept=".pdf,.jpg,.jpeg,.png"
              className="bg-light border-0"
              style={{ borderRadius: '10px' }}
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  // Handle file
                  handleChange('document', file);
                }
              }}
            />
            <Form.Text className="text-muted d-block mt-2" style={{ fontSize: '0.8rem' }}>
              Accepted formats: PDF, JPG, PNG
            </Form.Text>
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export default BankDetailsForm;
